/* global process */

var exportSettings = (function () {
  if (process.env.NODE_ENV === 'ci') {
    return {
      ssoHost: '/fakeelisaid', // localhost
      clientId: 'viihde_online_local',
      elisaIdEnabled: true,
      usagestatsEnabled: false,
      usagestatsURL: 'http://analytics-dev.elisaviihde.fi/usagestats/api/PlayerEvent',
      googleTagManagerId: 'GTM-WPL4F94'
    };
  }
  if (process.env.NODE_ENV === 'local') {
    return {
      ssoHost: '/fakeelisaid', // localhost
      clientId: 'viihde_online_local',
      elisaIdEnabled: true,
      usagestatsEnabled: true,
      usagestatsURL: 'http://analytics-dev.elisaviihde.fi/usagestats/api/PlayerEvent',
      googleTagManagerId: 'GTM-WPL4F94'
    };
  }
  if (process.env.NODE_ENV === 'production') {
    return {
      ssoHost: 'https://id.elisa.fi',
      clientId: 'viihde_online',
      elisaIdEnabled: true,
      usagestatsEnabled: true,
      usagestatsURL: 'https://analytics.saunalahti.fi/usagestats/api/PlayerEvent',
      googleTagManagerId: 'GTM-WPL4F94'
    };
  }
  if (process.env.NODE_ENV === 'test') {
    return {
      ssoHost: 'https://id-test.elisa.fi',
      clientId: 'viihde_online_test',
      elisaIdEnabled: true,
      usagestatsEnabled: true,
      usagestatsURL: 'http://analytics-dev.elisaviihde.fi/usagestats/api/PlayerEvent',
      googleTagManagerId: 'GTM-WPL4F94'
    };
  }
})();

export default exportSettings;



// WEBPACK FOOTER //
// ./web/js/settings.js